import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { safeLocalStorageGet, safeLocalStorageSet } from '@finvox/shared/storage';
import en from '@/locales/en.json';
import ar from '@/locales/ar.json';

export const LOCALE_BROADCAST = 'finvox-locale';

export async function initI18n(): Promise<void> {
  const saved = safeLocalStorageGet('finvox_locale') ?? 'en';
  await i18n.use(initReactI18next).init({
    resources: { en: { translation: en }, ar: { translation: ar } },
    lng: saved,
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    showSupportNotice: false
  });
  applyDocumentDirection(saved);
}

export function applyDocumentDirection(lng: string): void {
  const isAr = lng === 'ar';
  document.documentElement.lang = lng;
  document.documentElement.dir = isAr ? 'rtl' : 'ltr';
}

export function changeLanguage(lng: 'en' | 'ar'): void {
  safeLocalStorageSet('finvox_locale', lng);
  void i18n.changeLanguage(lng);
  applyDocumentDirection(lng);
  new BroadcastChannel(LOCALE_BROADCAST).postMessage({ lng });
}

export function subscribeLocaleBroadcast(onChange: (lng: 'en' | 'ar') => void): () => void {
  const channel = new BroadcastChannel(LOCALE_BROADCAST);
  channel.onmessage = (e: MessageEvent<{ lng?: string }>) => {
    if (e.data?.lng === 'en' || e.data?.lng === 'ar') {
      void i18n.changeLanguage(e.data.lng);
      applyDocumentDirection(e.data.lng);
      onChange(e.data.lng);
    }
  };
  return () => channel.close();
}

export default i18n;
